/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackProcedimentiTipologia =
  (typeof GetBackProcedimentiTipologia)[keyof typeof GetBackProcedimentiTipologia];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackProcedimentiTipologia = {
  PROCEDIMENTO: 'PROCEDIMENTO',
  PRATICA: 'PRATICA',
} as const;
